import React from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import { RootState } from '../../../store/store'
import { useSelector, useDispatch } from 'react-redux'
import { IAbsenceEntry } from '../../../interface/absenceEntry'
import { setEditEntry } from '../../../store/features/absences'

const AbsenceTimeContent = (): JSX.Element => {
  const dispatch = useDispatch()

  const absentTimesFromApi: Array<IAbsenceEntry> = useSelector((state: RootState) => state.entrys.absenceEntrys)

  const [maxShownItems, setMaxShownItems] = React.useState(5)

  const NoEntry = (): JSX.Element => {
    return (
      <div className="text-center py-5">
        <h4>In diesem Zeitraum wurden keine Abwesenheiten gefunden!</h4>
      </div>
    )
  }

  const RenderList = (): JSX.Element => {
    return (
      <>
        {absentTimesFromApi && absentTimesFromApi.length === 0 ? <NoEntry /> : <Entrys />}
      </>
    )
  }

  const confirmationIcon = (item: any): JSX.Element => {
    return (
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1 my-auto py-2">
        {item.confirmed === "1" ? (
          <i data-tip data-for="confirmed" className="fal fa-calendar-check time-confirmed-icon"></i>
        ) : (
          <i data-tip data-for="notConfirmed" className="fal fa-calendar-times time-not-confirmed-icon"></i>
        )}
      </div>
    )
  }

  const reason = (item: any): JSX.Element => {
    return (
      <div className="col-lg-5 col-md-5 col-sm-6 my-auto py-2">
        <small>Grund:</small>
        <br></br>
        {item.reason}
      </div>
    )
  }

  const dateAndTime = (item: any): JSX.Element => {
    return (
      <div className="col-lg-3 col-md-3 col-sm-5 my-auto py-2">
        <small>Datum und Uhrzeit:</small>
        <br></br>
        {item.fromDateGermanStyle === item.tillDateGermanStyle
          ? item.fromTime === "00:00"
            ? item.fromDateGermanStyle
            : item.fromDateGermanStyle + " " + item.fromTime + " bis " + item.tillTime + " Uhr"
          : item.fromDateGermanStyle + " bis " + item.tillDateGermanStyle}
      </div>
    )
  }

  const editButton = (item: any): JSX.Element => {
    return (
      <div className="col-lg-3 col-md-3 col-sm-12 my-auto py-2">
        {item.isActive === "1" ? (
          item.wholeDay === "0" ? (
            item.confirmed === "0" ? (
              <div>
                <Link className="btn btn-block btn-secondary" to="/abwesenheit-bearbeiten/" onClick={() => dispatch(setEditEntry(item))}>
                  <i className="fal fa-edit"></i> bearbeiten
                </Link>
              </div>
            ) : (
              <div className="col-12 my-1">
                <i className="fal fa-check mr-2 text-success-wbs"></i> bestätigt
              </div>
            )
          ) : (
            <button className="btn btn-block btn-secondary" disabled>
              <i className="fal fa-edit"></i> bearbeiten
            </button>
          )
        ) : (
          <div className="row">
            <div className="col-12 my-1">
              <i className="fal fa-exclamation-triangle mr-2 text-secondary-wbs"></i> deaktiviert
            </div>
          </div>
        )}
      </div>
    )
  }

  const entryClass = (item: any): string => {
    return item.isActive === "1" ? "row text-center learning-and-absence-entry-row-active" : "row text-center learning-and-absence-entry-row-not-active"
  }

  const Entrys = (): JSX.Element => {
    return (
      <>
        {absentTimesFromApi.slice(0, maxShownItems).map((item: IAbsenceEntry, index: number) => (
          <div className={entryClass(item)} key={index}>
            {dateAndTime(item)}
            {reason(item)}
            {confirmationIcon(item)}
            {editButton(item)}
          </div>
        ))}

        {
          maxShownItems < absentTimesFromApi.length && <div className="text-center">
            <div className="text-center">
              <div className="btn btn-primary my-3" onClick={() => setMaxShownItems(maxShownItems + 5)}>
                Mehr laden
              </div>
            </div>
          </div>
        }
      </>
    )
  }

  return (
    <>
      <ReactTooltip className="wbs-tooltip-blue" backgroundColor="#01254b" id="confirmed" place="top" effect="solid">
        Abwesenheit wurde bestätigt
      </ReactTooltip>

      <ReactTooltip className="wbs-tooltip-blue" backgroundColor="#01254b" id="notConfirmed" place="top" effect="solid">
        Abwesenheit wurde nocht nicht bestätigt
      </ReactTooltip>

      <RenderList />
    </>
  );
};

export default AbsenceTimeContent;
